import { Component } from '@angular/core';
import { IMenuCollection, UilabNavRailModule } from '@uilab/core-angular';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { UILAB_BASE_COMPONENT_PACKAGE } from '../../../shared/constants/dependencies.constants';

interface NavrailExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly items: IMenuCollection[];
    readonly activeRoute: string[];
}

@Component({
    selector: 'avd-navrail-examples',
    templateUrl: './navrail-examples.component.html',
    styleUrls: ['./navrail-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabNavRailModule,
    ],
})
export class NavrailExamplesComponent {
    readonly packageName = UILAB_BASE_COMPONENT_PACKAGE;
    readonly getStartedLink = undefined;
    readonly storybookLink =
        'https://purple-sand-05c79481e.6.azurestaticapps.net/?path=/story/organisms-nav-rail-v2--default';
    readonly repoLink = `https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?path=/packages/uilab-base/src/components/organisms/nav-rail-v2&version=GBmain&_a=contents`;

    readonly examples: readonly NavrailExample[] = [
        {
            variant: 'basic',
            label: 'Basic Nav rail',
            description:
                'Use a nav rail to expose primary destinations and keep navigation available across the app.',
            htmlSnippet: `<uilab-nav-rail
    [items]="items"
    [activeRoute]="['/build/components/button']"
    [subMenuType]="'sidesheet'"
    [collapsed]="false"
></uilab-nav-rail>`,
            items: [
                {
                    type: 'link',
                    name: 'Home',
                    icon: 'navigation--home',
                    linkData: {
                        href: '/build/',
                        data: '',
                    },
                },
                {
                    type: 'link',
                    name: 'Components',
                    icon: 'action--create-list',
                    linkData: {
                        href: '/build/components/button',
                        data: '',
                    },
                },
                {
                    type: 'link',
                    name: 'Patterns',
                    icon: 'navigation--applications',
                    linkData: {
                        href: '/build/patterns',
                        data: '',
                    },
                },
                {
                    type: 'divider',
                    name: '',
                },
                {
                    type: 'link',
                    name: 'Back to landing',
                    icon: 'navigation--back',
                    linkData: {
                        href: '/',
                        data: '',
                    },
                },
            ],
            activeRoute: ['/build/components/button'],
        },
    ];
}
